// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseSearchResultModelCaseCaseModel } from './caseSearchResultModelCaseCaseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CaseSearchResultModelCaseCaseModelResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': CaseSearchResultModelCaseCaseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseSearchResultModelCaseCaseModelResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "CaseSearchResultModelCaseCaseModel"
        },
    ];

    static getAttributeTypeMap() {
        return CaseSearchResultModelCaseCaseModelResponse.attributeTypeMap;
    }
}
